module.exports = __webpack_public_path__ + "media/images/bsmart/icons/da_valutare_scadenza-10333204840f05ae5cc59b34695e374d.svg";